import { useEffect, useMemo, useState } from "react";
import { useAssistant } from "../Assistants/Assistant";

const defaultPhoneNumberOption = {
  id: 0,
  label: "Please select phone number",
  value: "",
};
const defaultEmailOption = { id: 0, label: "Please select Email", value: "" };

function getDefaultIdentifierOption(assistant) {
  switch (assistant.assistantType) {
    case "email":
      return defaultEmailOption;
    case "call":
    case "sms":
    case "whatsapp":
    default:
      return defaultPhoneNumberOption;
  }
}

export default function useAssistantCommunicationBinding({
  assistantId,
  workspaceId,
  campaignType,
}) {
  const [fromIdentifier, setFromIdentifier] = useState("");
  const { assistant, fetchAssistant } = useAssistant(assistantId, workspaceId);

  useEffect(() => {
    if (assistantId && workspaceId) {
      fetchAssistant();
    }
  }, [assistantId, workspaceId]);

  const availableIdentifierOptions = useMemo(() => {
    if (assistant) {
      return assistant?.communicationBinding?.map((binding, idx) => {
        return {
          id: idx + 1,
          label: binding.identifier,
          value: binding.identifier,
        };
      });
    }

    return [];
  }, [assistant]);

  return {
    identifierOptions: [
      getDefaultIdentifierOption(campaignType),
      ...availableIdentifierOptions,
    ],
    fromIdentifier,
    setFromIdentifier,
    availableIdentifiers: assistant?.communicationBinding ?? [],
  };
}
